import React from "react";
import KeywordsTag from './KeywordsTag';

const People = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="peoplePublic"
        handwritingSrc="../../content/handwriting/people.png"
        handwritingAlt="people"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default People;